<script>
import bem from '@/utils/bem';
import PencilIcon from '@/components/svg/PencilIcon/PencilIcon.vue';
import CustomImage from './custom-image.vue';
import TitleBlock from './title-block.vue';
import styles from './story-card-style.scss';

const b = bem('story-card', styles);

export default {
  name: 'StoryCard',
  components: {
    PencilIcon,
    CustomImage,
    TitleBlock,
  },
  props: {
    className: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    isMobileView: {
      type: Boolean,
      default: false,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['edit-image', 'edit-title'],
  computed: {
    b() {
      return b;
    },
    displayImage() {
      if (this.isMobileView && this.item.imageUrlMobile) {
        return this.item.imageUrlMobile;
      }
      return this.item.imageUrl || '';
    },
    imageText() {
      return this.isMobileView ? `${this.item.id}. ${this.item.titleMobile || this.item.title}` : '';
    },
    desktopTitle() {
      return `${this.item.id}. ${this.item.title}`;
    },
    mobileTitle() {
      return `${this.item.id}. ${this.item.titleMobile || this.item.title}`;
    },
  },
};
</script>

<template>
  <section :class="b({ mix: className, isMobileView, isEditMode })" :key="item.id">
    <div
      :class="b('image-wrap', { editable: isEditMode, isMobileView })"
      :role="isEditMode ? 'button' : undefined"
      :tabindex="isEditMode ? 0 : undefined"
      @click="isEditMode && $emit('edit-image')"
      @keyup.enter="isEditMode && $emit('edit-image')"
      @keyup.space="isEditMode && $emit('edit-image')"
    >
      <div v-if="!displayImage" :class="b('image-placeholder', { isMobileView })">
        <span :class="b('placeholder-text')">
          <span :class="b('placeholder-plus')">+</span>
          <br>CLICK TO UPLOAD
        </span>
      </div>
      <custom-image
        v-else
        :class="b('image', { isMobileView })"
        :image-uri="displayImage"
        alt="story-image"
        :without-shadow="true"
        :with-gradient="true"
        :is-dark-gradient="true"
        :text="imageText"
        :class-name-text="b('title', { isMobileView })"
        :is-mobile-view="isMobileView"
      />
      <div v-if="isEditMode && displayImage" :class="b('image-edit-overlay')">
        <PencilIcon color="#ffffff" :size="24" />
      </div>
    </div>

    <line
      v-if="isMobileView"
      :class="b('line', { isMobileView })"
      :is-small="true"
      :is-reverse="true"
      :is-white="true"
      :is-mobile-view="isMobileView"
    />

    <div
      v-if="!isMobileView"
      :class="b('title-wrap', { editable: isEditMode })"
      :role="isEditMode ? 'button' : undefined"
      :tabindex="isEditMode ? 0 : undefined"
      @click="isEditMode && $emit('edit-title')"
      @keyup.enter="isEditMode && $emit('edit-title')"
      @keyup.space="isEditMode && $emit('edit-title')"
    >
      <title-block
        :class="b('title', { isMobileView })"
        :is-white="true"
        :is-mini="true"
        :is-mobile-view="isMobileView"
      >
        {{ desktopTitle }}
      </title-block>
      <PencilIcon
        v-if="isEditMode"
        :class="b('edit-icon')"
        color="#ffffff"
        :size="16"
      />
    </div>

  </section>
</template>
